<template>
    <ul class="list-group">
        <li v-for="(help, index) in helps" :key="index" class="list-group-item">
            <h5 class="mb-1">{{ help.title }}</h5>
            <small v-if="help.urlRef" class="text-muted">
                Referencia: {{ help.urlRef }}
            </small>
            <div class="text-right">
                <b-button class="mb-3 mr-1" variant="danger" v-if="superUser" @click="deleteHelp(help.id)">
                    Borrar
                </b-button>
                <b-button class="mb-3 mr-1" variant="success" @click="more(help.id)">
                    Ver mas
                </b-button>
            </div>
        </li>
        <li v-if="!helps" class="list-group-item">No hay ayuda</li>
    </ul>
</template>
  
<script>

import utilsService from "../../services/utils";
import helpService from "../../services/help";

export default {
    name: "HelpComponent",
    props: {
        helps: {
            type: Array,
            required: true,
        },
        superUser: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            role: localStorage.getItem("role")
        }
    },
    methods: {
        deleteHelp(id) {
            let self = this;

            this.$awn.asyncBlock(
                helpService.delete(id),
                (response) => {
                    if (response) {
                        //utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_CONTACTS", info: "" });
                        self.$root.$emit("getHelps");
                    }
                },
                (error) => {
                    utilsService.auditErrorFrontent({
                        info: "patientService.create",
                        module: "view-pages-professional-contact-contacts",
                        httpStatus: error.response ? error.response.status : null,
                        endpoint: window.location.href,
                        request: JSON.stringify({
                            data: data
                        })
                    });
                },
                " "
            );
        },
        more(id) {
            this.$router.push({
                name: "auth.help",
                query: { id: id },
            });
        },
        getAuthentication() {
            return localStorage.getItem('authorization');
        },
    }
};
</script>